export default __webpack_public_path__ + "images/slide_7.jpeg?df057f6525f7ddf4e49674facf8f4e42";